var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncement02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 13.9999 1.5747 6.2986c.0442.1771.0664.2657.0926.343a2 2 0 0 0 1.7312 1.3518c.0814.0066.1727.0066.3553.0066.2286 0 .343 0 .4393-.0093a2 2 0 0 0 1.7976-1.7976C10 20.0967 10 19.9823 10 19.7537V5.4999m8.5 8c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5m-8.25-1H6.5C4.0147 5.5 2 7.5146 2 10s2.0147 4.5 4.5 4.5h3.75c1.7664 0 3.9272.9469 5.5943 1.8557.9725.5301 1.4588.7952 1.7773.7562.2953-.0362.5186-.1688.6917-.4108.1867-.2609.1867-.7831.1867-1.8274V5.1262c0-1.0443 0-1.5664-.1867-1.8274-.1731-.242-.3964-.3746-.6917-.4108-.3185-.039-.8048.2261-1.7773.7563-1.6671.9087-3.8279 1.8556-5.5943 1.8556",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement02);
export default __webpack_public_path__ + "static/media/announcement-02.ad1d920789b610bdc5ad09859fd0be8e.svg";
export { ForwardRef as ReactComponent };